<template>
  <div>
    <slot name="label">
      <template v-if="label">
        <label>{{label}}</label>
        <br>
      </template>
    </slot>
    <el-select class="select-default max-step-width role-autocomplete"
               filterable
               autocomplete="new-password"
               :value="roleValue"
               :loading="loading"
               clearable
               @change="onChange"
               :placeholder="$t('generic.searchOrCreate')"
               v-bind="$attrs"
               value-key="name">
      <el-option v-for="role in roles.data"
                 class="select-default"
                 :key="role.id"
                 :label="role.name"
                 :value="role">
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui';
  import throttle from 'lodash/throttle';
  import RoleService from 'src/services/RoleService';
  export default {
    name: 'role-autocomplete',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      role: {
        type: Object,
        default: () => {
          return {
            name: ''
          }
        }
      },
      label: {
        type: String
      },
      filterQuery: String,
      excludeQuery: String,
    },
    model: {
      prop: 'role',
      event: 'change'
    },
    data() {
      return {
        loading: false,
        roles: []
      }
    },
    computed: {
      roleValue() {
        if (!this.role.id) {
          return this.role.name;
        }
        return this.role;
      }
    },
    methods: {
      async searchRoles(query) {
        try {
          this.loading = true;
          this.roles = await RoleService.get({ query, limit: 50 });
          if (this.filterQuery) {
            this.roles.data = this.roles.data.filter(r => {
              let matchesExcludeQuery = true
              const matchesQuery = r.name.includes(this.filterQuery)

              if (this.excludeQuery) {
                matchesExcludeQuery = !r.name.includes(this.excludeQuery)
              }
              return matchesExcludeQuery && matchesQuery
            })
          }
        } catch (e) {
          console.warn(e);
        } finally {
          this.loading = false;
        }
      },
      onChange(val) {
        if (!val) {
          this.onRemoteMethod(val);
        }
        let model = val;
        if (typeof val === 'string') {
          model = {
            name: val
          };
        }
        this.$emit('change', model);
      }
    },
    created() {
      this.onRemoteMethod = throttle(this.searchRoles, 200);
    },
    mounted() {
      this.searchRoles(this.role.name);
    }
  }
</script>
<style lang="scss">
  .role-autocomplete {
    &.max-step-width {
      width: 320px;
      max-width: 320px;
    }
  }
</style>
